var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 25C1.875 26.0547 2.69531 26.875 3.75 26.875H13.125V17.5H1.875V25ZM16.875 26.875H26.25C27.2461 26.875 28.125 26.0547 28.125 25V17.5H16.875V26.875ZM28.125 8.125H25.6055C26.0156 7.42188 26.25 6.66016 26.25 5.78125C26.25 2.96875 23.9062 0.625 21.0938 0.625C18.6328 0.625 17.0508 1.91406 15.0586 4.66797C13.0078 1.91406 11.4258 0.625 9.02344 0.625C6.15234 0.625 3.86719 2.96875 3.86719 5.78125C3.86719 6.66016 4.04297 7.42188 4.45312 8.125H1.875C0.820312 8.125 0 9.00391 0 10V14.6875C0 15.2148 0.410156 15.625 0.9375 15.625H29.0625C29.5312 15.625 30 15.2148 30 14.6875V10C30 9.00391 29.1211 8.125 28.125 8.125ZM8.96484 8.125C7.67578 8.125 6.62109 7.12891 6.62109 5.78125C6.62109 4.49219 7.67578 3.4375 8.96484 3.4375C10.1367 3.4375 11.0156 3.67188 14.0625 8.125H8.96484ZM21.0938 8.125H15.9961C19.043 3.67188 19.8633 3.4375 21.0938 3.4375C22.3828 3.4375 23.4375 4.49219 23.4375 5.78125C23.4375 7.12891 22.3828 8.125 21.0938 8.125Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9a3091d28b38c6dab1172755f0ff7ef1.svg";
export { ForwardRef as ReactComponent };